import styled from 'styled-components'
import { respondTo } from '../../styles/_respondTo'

export const NavbarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
  color: white;
  height: 8vh;
`

export const UlContainer = styled.ul`
  list-style: none;
  display: flex;
  padding: 0;
`

export const Li = styled.li`
  text-decoration: none;
  margin-right: 5px;
`

export const ElementNav = styled.a`
  text-decoration: none;
  color: #5B5A5A;
  font-weight: bold;
  transition: 300ms ease color;
  font-size: 1.1rem;

  &:hover {
    color: #474545;
  }
`

export const NamePerson = styled.h1`
  margin: 15px 0;
  font-size: 24px;
  text-align: center;
  color: #41C7C7;
  font-weight: bold;

  ${respondTo.xs`
    font-size: 24px;

  `}

  ${respondTo.sm`
    font-size: 24px;
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
    font-size: 35px;
  `}

  ${respondTo.xl`
    font-size: 35px;

  `}


`

